import { InjectionToken } from '@angular/core';

export const VALIDATION_NOTIFIER_HANDLERS = new InjectionToken(
  'VALIDATION_NOTIFIER_HANDLERS',
);
